module.exports = __webpack_public_path__ + "images/location-marker.c922538d5fb4d9906fea.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/location-marker.png
// module id = V6fC
// module chunks = 24